/**
 * Import React libraries.
 */
import * as React from 'react';

/**
 * Import custom styles.
 */
import { FilterChipContainer } from './ChipStyles';

/**
 * Import custom types.
 */
import { ChipValue, ChoiceChipProps } from './ChipTypes';

const ChoiceChips: React.FunctionComponent<ChoiceChipProps> = ({ selected, variant, size, disabled, onClick, values }: ChoiceChipProps) => {
  /**
   * Globally used variables within the component.
   */
  const [selectedChip, setSelectedChip] = React.useState<string>('');

  /**
   * Set the selected value for the chip.
   */
  React.useEffect(() => {
    setSelectedChip(selected);
  }, [selected]);

  /**
   * Sets selected chip and fires an event to parent component.
   * @param value - Chip which was selected.
   */
  const onSelectChip = (value: ChipValue) => {
    // Update selected chip
    setSelectedChip(value.value);

    // Fire the event
    onClick(value)
  };

  /**
   * Return Choice Chip component.
   */
  return (
    <>
      {
        values.map((value: ChipValue) =>
          <FilterChipContainer key={value.value} className={`${size} ${disabled ? 'disabled' : selectedChip === value.value ? 'selected' : variant}`} onClick={() => onSelectChip(value)}>
            {value.label}
          </FilterChipContainer>
        )
      }
    </>
  );
};

export default ChoiceChips;
